import React, { Component } from "react";
import Lightbox from "react-image-lightbox";
import Alert from "react-s-alert";

import ImageCanvasEditor from "../../component/image-canvas-editor/image-canvas-editor";
import Loading from "../../component/Loading";
import PhotoTaskSlider from "../../component/PhotoTaskSlider";
import TaskPriority from "../../component/TaskPriority";
import { API_URL_LOGIN } from "../../config/config";
import { PHOTO_REVIEW } from "../../config/lang";
import { TaskEdit } from "../task/Edit";

import { call } from "../../util/action";
import {
  dateFormat,
  reviewTaskSalePriceMonitoring,
  reviewTaskPriceMonitoring,
  reviewMerchandiserNamePhone,
  reviewTaskVisitPoint,
  reviewTaskSupervisor,
  getApproveRejectInfo,
  reviewCreatedByTaskSupervisor,
} from "../../util/formatter";
import { getStore } from "../../util/redux/store";
import { translate } from "../../util/util";

import "./style.scss";

const me = getStore().getState().me;
class Preview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
      apiAnswerData: null,
      answerLoading: false,
      logoError: false,
    };
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount = () => {
    document.addEventListener("keydown", this.handleKeyDown, false);
    const { item } = this.props;

    if (item.picsell_info?.object_type === "answer") {
      this.fetchAnswerData();
    }
    this.setState({ logoError: false });
  };

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
  }

  componentDidUpdate(prevProps) {
    const { item } = this.props;

    if (prevProps.item?.id !== item?.id) {
      this.setState({ logoError: false });
    }

    if (item.picsell_info?.object_type === "answer" && prevProps.item.picsell_info?.object_id !== item.picsell_info?.object_id) {
      this.setState({ apiAnswerData: null });
      this.fetchAnswerData();
    }

    if (this.props.isResetPhotoItem !== prevProps.isResetPhotoItem && this.props.gridViewMode === "group") {
      this.setState({ photoIndex: 0 });
    }
  }

  handleKeyDown = e => {
    let { acceptRejectAnswer, passTaskToModal, moveNext } = this.props;

    switch (e.code) {
      case "ArrowLeft":
        moveNext(-1);
        break;
      case "ArrowRight":
        moveNext(+1);
        break;
      case "ArrowUp":
        acceptRejectAnswer("ACCEPT");
        break;
      case "ArrowDown":
        passTaskToModal();
        break;
    }
  };

  deleteImage = idx => {
    let images = this.props.editBlockData.item.images;
    let id = images[idx].id;
    // delete images[idx];
    this.props.editBlockData.onChange("images", []);

    call({ method: "DELETE", url: "images/" + id + "/", body: {} }, () => {
      Alert.success("Image successfully deleted", { position: "top" });
    });
  };

  handleDownlodDetailsPhoto = async e => {
    e.preventDefault();
    e.stopPropagation();

    const image = await fetch(`${e.currentTarget?.href}?chunk=${Date.now()}`); // expected <a href> link  or this.props.item.photo
    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    // const imageName = imageURL.substring(imageURL.lastIndexOf("/") + 1);
    const imageName = this.getPhotoName();
    const link = document.createElement("a");

    link.href = imageURL;
    link.download = `${imageName}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  getPhotoName = () => {
    const dateString = dateFormat(this.props.item.visit?.start);
    const [datePart, timePart] = dateString.split(" ");
    const [day, month, year] = datePart.split("/");
    const [hours, minutes] = timePart.split(":");
    const pointName = this.props.item.visit?.point?.name;
    const pointNameString = pointName.replace(/\s+/g, "_");

    const formattedDate = `${day}_${month}_${year}_${hours}_${minutes}_${pointNameString}`;

    return formattedDate;
  };

  isMonitoringData = () => {
    const item = this.props.item;
    return reviewTaskPriceMonitoring("", item) || reviewTaskSalePriceMonitoring("", item) ? true : false;
  };

  activePhotoIndex = (index = 0) => {
    this.setState({ photoIndex: index });
    return index;
  };

  //check if value is function or object
  isFunctionOrObject = value => {
    return value !== null && typeof value === "function";
  };

  fetchAnswerData = async () => {
    this.setState({ answerLoading: true });

    let { item } = this.props;
    let answerId = item.picsell_info?.object_id;

    call({ method: "GET", url: `answers/${answerId}/` }, data => {
      this.setState({ apiAnswerData: data, answerLoading: false });
    });
  };

  render() {
    let { item, acceptRejectAnswer, passTaskToModal, editBlockData, isLoading, gridViewMode, openFullPhotoList } = this.props;
    const { apiAnswerData, answerLoading } = this.state;
    editBlockData = this.isFunctionOrObject(editBlockData) ? editBlockData() : editBlockData;
    if (!item) {
      return null;
    }

    const tagList = Array.isArray(item?.additional_info?.tags)
      ? item.additional_info.tags
      : typeof item?.additional_info?.tags === "string" && item.additional_info.tags
      ? [item.additional_info.tags]
      : [];

    let siteUrl = API_URL_LOGIN;
    siteUrl = siteUrl.replace("/login/", "");
    return (
      <div className="item taskBlock" data-photo-current-index={this.state.photoIndex}>
        <Loading loading={isLoading} disP={true} type="spinner" />
        <div className="col-md-5 pr-2 photoContainer photo-carousel">
          <div className={`original-photo-cover ${editBlockData.isModal > 0 ? "hidden" : ""}`}>
            <div className={`original-photo original-photos-wrapper ${editBlockData.isModal > 0 ? "hidden" : ""}`}>
              {gridViewMode === "single" ? (
                <div className="photo-review-list">
                  {/* {console.log(item, "ITEM")} */}
                  {item.photo ? (
                    <img src={item.photo[item.quickItemPhotoIndex] ? item.photo[item.quickItemPhotoIndex] : item.photo[0]} className="previewImage" />
                  ) : item.url_photo ? (
                    <img src={item.url_photo} className="previewImage" />
                  ) : (
                    <h5>Photo Not found</h5>
                  )}
                </div>
              ) : (
                <PhotoTaskSlider
                  activePhotoIndex={this.activePhotoIndex}
                  quickItemPhotoIndex={item.quickItemPhotoIndex}
                  photos={item.photo}
                  isDeepArray={true}
                  clickCallback={index => {
                    openFullPhotoList(index);
                  }}
                  viewMode={gridViewMode}
                />
              )}
              <div className="pr-photo-nav">
                {(() => {
                  const photos = item.photo ? item.photo : item.url_photo ? [item.url_photo] : [];
                  const activePhoto = photos[this.state.photoIndex] || photos[0];
                  if (!activePhoto) return null;
                  return (
                    <div className="pr-photo-nav-btns">
                      <a href={activePhoto} target="_blank" className="pr-icon-btn" title="Відкрити">
                        <span className="material-symbols-outlined">open_in_full</span>
                      </a>
                      <a href={activePhoto} download className="pr-icon-btn" title="Завантажити" onClick={this.handleDownlodDetailsPhoto}>
                        <span className="material-symbols-outlined">cloud_download</span>
                      </a>
                    </div>
                  );
                })()}
              </div>
            </div>
          </div>
          <div className={`pr-action-bar ${editBlockData.isModal > 0 ? "hidden" : ""}`}>
            <button
              className={`pr-action-btn pr-action-btn--approve${item.approval?.is_approved === true ? " pr-action-btn--active" : ""}`}
              onClick={() => acceptRejectAnswer("ACCEPT")}
              title={translate(PHOTO_REVIEW, "approv_btn", me.language)}>
              <span className="material-symbols-outlined">check_circle</span>
              <span>{translate(PHOTO_REVIEW, "approv_btn", me.language)}</span>
            </button>
            <button
              className={`pr-action-btn pr-action-btn--reject${item.approval?.is_approved === false ? " pr-action-btn--active" : ""}`}
              onClick={() => passTaskToModal(this.state.photoIndex)}
              title={translate(PHOTO_REVIEW, "reject_btn", me.language)}>
              <span className="material-symbols-outlined">cancel</span>
              <span>{translate(PHOTO_REVIEW, "reject_btn", me.language)}</span>
            </button>
          </div>
          {editBlockData.item?.images?.length > 0 && editBlockData.isModal ? (
            <div className="taskImagesEdit">
              {editBlockData.item?.images?.map((image, idx) => (
                <div key={idx} className="d-flex">
                  <img src={image.image} onClick={editBlockData.setOpen} />
                  <div className="previewPhotoNav">
                    {editBlockData.isImageEditable && <ImageCanvasEditor src={image.image} id={idx} onSaveImage={editBlockData.onSaveEditorImage} />}
                    {/*   <button type="button" className="btn btn-primary btn-sm white" onClick={this.onModalToggle}>
                      <i className="fa fa-edit" />
                    </button> */}
                    <button type="button" onClick={() => this.deleteImage(idx)}>
                      <i className="fa fa-minus-square-o" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="col-md-7 pr-detail-col">
          <div className={`pr-detail ${editBlockData.isModal ? "hidden" : ""}`}>
            {/* Header: logo + store name + locality */}
            <div className="pr-detail-header">
              {item.visit?.point?.image && !this.state.logoError ? (
                <img
                  src={`${siteUrl}${item.visit.point.image}`}
                  className="pr-detail-logo"
                  alt={item.visit?.point?.name}
                  onError={() => this.setState({ logoError: true })}
                />
              ) : (
                <div className="pr-detail-logo-fallback">
                  <span className="material-symbols-outlined">store</span>
                </div>
              )}
              <div className="pr-detail-location">
                <div className="pr-detail-storename">{reviewTaskVisitPoint("", item)}</div>
                <div className="pr-detail-locality">{item.visit?.point?.locality?.name}</div>
              </div>
            </div>

            {/* Tags */}
            {tagList.length > 0 && (
              <div className="pr-chips">
                {tagList.map(t => (
                  <span key={t} className="pr-chip">
                    {t}
                  </span>
                ))}
              </div>
            )}

            {/* Main info card */}
            <div className="pr-info-card">
              <div className="pr-info-row">
                <span className="pr-info-label">{translate(PHOTO_REVIEW, "merchendiser", me.language)}</span>
                <div className="pr-info-value">{reviewMerchandiserNamePhone("", item)}</div>
              </div>
              <div className="pr-info-row">
                <span className="pr-info-label">{translate(PHOTO_REVIEW, "responsible_supervisor", me.language)}</span>
                <div className="pr-info-value">{reviewTaskSupervisor("", item)}</div>
              </div>
              {item.approval?.approved_at && (
                <div className="pr-info-row">
                  <span className="pr-info-label">{translate(PHOTO_REVIEW, "approve_reject_label_block", me.language)}</span>
                  <div className="pr-info-value">
                    <span
                      className={`pr-status-chip${
                        item.approval.is_approved === true
                          ? " pr-status-chip--approved"
                          : item.approval.is_approved === false
                          ? " pr-status-chip--rejected"
                          : ""
                      }`}>
                      {item.approval.is_approved === true
                        ? translate(PHOTO_REVIEW, "approved", me.language)
                        : item.approval.is_approved === false
                        ? translate(PHOTO_REVIEW, "rejected", me.language)
                        : ""}
                    </span>
                    <span className="pr-info-meta">
                      {getApproveRejectInfo("name", item.approval)} ({dateFormat(item.approval.approved_at)})
                    </span>
                  </div>
                </div>
              )}
              <div className="pr-info-row">
                <span className="pr-info-label">{translate(PHOTO_REVIEW, "linkedVisit", me.language)}</span>
                <div className="pr-info-value">
                  <a href={`${window.location.origin}/visit/${item.visit_id}`} className="pr-link" target="_blank" rel="noopener noreferrer">
                    <span className="material-symbols-outlined pr-link-icon">link</span>
                    {item.visit?.point?.locality?.name} {item.visit?.point?.name}
                  </a>
                </div>
              </div>
              <div className="pr-info-row">
                <span className="pr-info-label">{translate(PHOTO_REVIEW, "start_visit", me.language)}</span>
                <div className="pr-info-value">{dateFormat(item.visit?.start)}</div>
              </div>
              <div className="pr-info-row">
                <span className="pr-info-label">{translate(PHOTO_REVIEW, "end_visit", me.language)}</span>
                <div className="pr-info-value">{dateFormat(item.visit?.end)}</div>
              </div>
              {item?.additional_info?.comment && (
                <div className="pr-info-row">
                  <span className="pr-info-label">{translate(PHOTO_REVIEW, "comment", me.language)}</span>
                  <div className="pr-info-value">{item.additional_info.comment}</div>
                </div>
              )}
            </div>

            {/* Price monitoring */}
            {this.isMonitoringData() && (
              <>
                <div className="pr-section-title">{translate(PHOTO_REVIEW, "price_monitoring", me.language)}</div>
                <div className="pr-info-card">
                  {reviewTaskPriceMonitoring("", item) && (
                    <div className="pr-info-row">
                      <span className="pr-info-label">{translate(PHOTO_REVIEW, "price", me.language)}</span>
                      <div className="pr-info-value">{reviewTaskPriceMonitoring("", item)}</div>
                    </div>
                  )}
                  {reviewTaskSalePriceMonitoring("", item) && (
                    <div className="pr-info-row">
                      <span className="pr-info-label">{translate(PHOTO_REVIEW, "sales_price", me.language)}</span>
                      <div className="pr-info-value">{reviewTaskSalePriceMonitoring("", item)}</div>
                    </div>
                  )}
                </div>
              </>
            )}

            {/* Answer block */}
            {item.picsell_info?.object_type === "answer" && !answerLoading && apiAnswerData !== null && apiAnswerData?.task != null && (
              <>
                <div className="pr-section-title">{translate(PHOTO_REVIEW, "answer", me.language)}</div>
                <div className="pr-info-card">
                  <div className="pr-info-row">
                    <span className="pr-info-label">{translate(PHOTO_REVIEW, "linkedTasks", me.language)}</span>
                    <a href={`${window.location.origin}/task/${apiAnswerData?.task.id}`} className="pr-link" target="_blank" rel="noopener noreferrer">
                      <span className="material-symbols-outlined pr-link-icon">link</span>
                      {apiAnswerData?.task.id} — {apiAnswerData?.task.title}
                    </a>
                  </div>
                  <div className="pr-info-row">
                    <span className="pr-info-label">{translate(PHOTO_REVIEW, "description", me.language)}</span>
                    <span className="pr-info-value">{apiAnswerData?.answer}</span>
                  </div>
                  <div className="pr-info-row">
                    <span className="pr-info-label">{translate(PHOTO_REVIEW, "created_by", me.language)}</span>
                    <span className="pr-info-value">{reviewCreatedByTaskSupervisor(apiAnswerData)}</span>
                  </div>
                  {apiAnswerData?.boolean_answer !== null && apiAnswerData?.boolean_answer !== undefined && (
                    <div className="pr-info-row">
                      <span className="pr-info-label">{translate(PHOTO_REVIEW, "answer", me.language)}</span>
                      <span className="pr-info-value">
                        {apiAnswerData.boolean_answer ? translate(PHOTO_REVIEW, "yes", me.language) : translate(PHOTO_REVIEW, "no", me.language)}
                      </span>
                    </div>
                  )}
                  <div className="pr-info-row">
                    <span className="pr-info-label">{translate(PHOTO_REVIEW, "priority", me.language)}</span>
                    <span className="pr-info-value">
                      <TaskPriority priority={apiAnswerData?.task.priority} />
                    </span>
                  </div>
                  <div className="pr-info-row">
                    <span className="pr-info-label">{translate(PHOTO_REVIEW, "status", me.language)}</span>
                    <span className="pr-status-chip static-status-color">{apiAnswerData?.task.status}</span>
                  </div>
                </div>
              </>
            )}
          </div>
          {editBlockData.isModal ? (
            <div className="text-left new-task-wrapper p-2">
              <Loading loading={editBlockData.newTaskLoading} disP={true} type="spinner" />
              <TaskEdit {...editBlockData} />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

export default Preview;
